// Redirect to 15 off 5 if on 5 for 50 while waiting for the 5 for 50 collection to be updated by NPD
(function () {
  if (window.location.pathname === "/collections/5-for-50") {
    window.location.replace("/collections/10-off-5");
  }
})();

window.normalizeOccasion =
  window.normalizeOccasion ||
  function (value = "") {
    return String(value)
      .normalize("NFKC")
      .toLowerCase()
      .replace(/[\u2018\u2019\u0060\u00B4]/g, "'")
      .replace(/\s+/g, " ")
      .trim();
  };

function getFocusableElements(container) {
  if (container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
      ),
    );
  } else {
    return [];
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
  }

  connectedCallback() {
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
    this.querySelectorAll("button > *, button > * > *").forEach((button) =>
      console.log("testing"),
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    window.toggleCartLoaders && window.toggleCartLoaders();
    const previousValue = this.input.value;
    var button = event.target;
    if (event.target.nodeName == "SPAN") {
      var button = event.target.parentElement;
    }
    const { name, value } = button;
    const key = button.dataset.id;

    if (name === "remove") {
      // if(button.classList.contains('remove-only-remove-button')) {
      //   window.trackCart?.track(window.trackCart.events.removePersonalization_start);
      //   window.trackCart?.saveEvenName(window.trackCart.events.removePersonalization_end);
      // } else {
      //   window.trackCart?.track(window.trackCart.events.removeItem_start);
      //   window.trackCart?.saveEvenName(window.trackCart.events.removeItem_end);
      // }
      if (value) {
        window.lovepop?.cart
          ?.removeByCode(value)
          .then((res) => {
            console.log(res);
          })
          .catch(console.error)
          .finally(() => {
            window.reloadCart(true);
          });
        return;
      }

      if (key) {
        window.lovepop?.cart
          ?.removeByKey(key)
          .then((res) => {
            console.log(res);
          })
          .catch(console.error)
          .finally(() => {
            window.reloadCart(true);
          });
        return;
      }
    }
    name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      const customChangeEvent = new CustomEvent('change', {
        detail: {
          direction: name === "plus" ? "increase" : "decrease",
        },
        bubbles: true  // optional: allow it to bubble up the DOM
      })
      this.input.dispatchEvent(customChangeEvent);
    }

    window.toggleCartLoaders && window.toggleCartLoaders(true);
  }
}

customElements.define("quantity-input", QuantityInput);

if (typeof debounce !== "function") {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('[id^="ModalClose-"]').forEach((closeButton) => {
      closeButton.addEventListener("click", this.hide.bind(this, false));
    });
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    // add parrent class
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      console.log("modal", modal);
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));

    const productEl = document.querySelector('script#ProductJson');
    this.productData = productEl ? JSON.parse(productEl.textContent).product : null;
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );

      this.video = this.querySelector("video");
      this.video.setAttribute("muted", true);
      this.video.setAttribute("playsinline", true);
      if (this.dataset.showControls !== "true") {
        this.video.removeAttribute("controls");
      }
      this.video.play();

      if (this.productData?.title?.includes("Music")) {
        this.bindSoundToggleEvents();
      }

      if (focus) deferredElement.focus();

      window.dispatchEvent(new CustomEvent("deferredMediaLoaded", {}));
    } else {
      this.video.play();
    }
  }

  bindSoundToggleEvents() {
    const videoSoundToggleBtn = this.querySelector(".video-sound button");
    if (!videoSoundToggleBtn) return;

    // Set initial state to muted
    this.video.muted = true;
    videoSoundToggleBtn.setAttribute("data-state", "muted");
    this.querySelector(".video-sound__icon--muted").style.display = "block";
    this.querySelector(".video-sound__icon--unmuted").style.display = "none";

    const onClick = () => {
      // Toggle mute state
      const isMuted = !this.video.muted;
      this.video.muted = isMuted;

      console.log("Setting mute state to: IsMuted", isMuted);
      videoSoundToggleBtn.setAttribute("data-state", isMuted ? "muted" : "unmuted");
      this.querySelector(".video-sound__icon--muted").style.display = isMuted ? "block" : "none";
      this.querySelector(".video-sound__icon--unmuted").style.display = isMuted ? "none" : "block";
      this.video.setAttribute("muted", isMuted);
    };

    videoSoundToggleBtn.removeEventListener("click", onClick.bind(this));
    videoSoundToggleBtn.addEventListener("click", onClick.bind(this));

    this.querySelector('.video-sound').style.display = "flex";
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = true;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    if (this.dataset.type == "thumbnail") {
      window.dispatchEvent(new CustomEvent("slideInit"), {});
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
      this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
            data: this.dataset,
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    console.log("clicking on slider arrows");
    event.preventDefault();
    const step = 1; //event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;

    if (
      this.slider.clientWidth + this.slider.scrollLeft >=
      this.slider.scrollWidth &&
      this.sliderItemsToShow[
        this.sliderItemsToShow.length - 1
      ].classList.contains("is-active")
    ) {
      this.slider.scrollTo({
        left: 0,
      });
    } else {
      this.slider.scrollTo({
        left: this.slideScrollPosition,
        behavior: "smooth",
      });
    }
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this),
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active",
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
        this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) +
        1 -
        this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`,
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
      ),
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut,
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// class SpecialOrder extends HTMLElement {
//   constructor() {
//     super();

//     this.expandTrigger = this.querySelector(".special-order__open-trigger");
//     this.closeTrigger = this.querySelector(".special-order__close-trigger");

//     this.init();
//   }

//   init() {
//     //prevent hover on mobile
//     this.addEventListener("touchstart", (e) => {
//       console.log("touchstart");

//       e.stopImmediatePropagation();
//       e.stopPropagation();
//     });

//     this.expandTrigger.addEventListener(
//       "click",
//       this.expandDetailedView.bind(this),
//     );
//     this.closeTrigger.addEventListener(
//       "click",
//       this.collapseDetailedView.bind(this),
//     );
//   }

//   expandDetailedView(e) {
//     e.preventDefault();
//     e.stopPropagation();

//     if (
//       this.closest(".constructor-autocomplete--products") &&
//       window.innerWidth < 1280
//     ) {
//       if (this.closest("product-card")) {
//         window.location.href = this.closest("product-card").getAttribute("url");
//         return;
//       }
//     }

//     if (this.classList.contains("expanded")) return;

//     this.classList.add("expanded");
//   }

//   collapseDetailedView(e) {
//     e.preventDefault();
//     e.stopPropagation();
//     if (!this.classList.contains("expanded")) return;

//     this.classList.remove("expanded");
//   }
// }

//customElements.define('special-order', SpecialOrder);

class SpecialOrder extends HTMLElement {
  constructor() {
    super();

    this.header = this.querySelector(".special-order__header");
    this.isPLP = this.header?.classList.contains("plp-trigger"); // Check if it's on PLP
    this.matchMediaQuery = window.matchMedia("(max-width: 990px)");

    this.init();
  }

  init() {
    // Initialize event listeners and resize handling
    this.updateEventListeners();

    // Listen for viewport changes for PLP
    if (this.isPLP) {
      this.matchMediaQuery.addEventListener(
        "change",
        this.updateEventListeners.bind(this),
      );
    }
  }

  updateEventListeners() {
    const isPLPAndShouldApply = this.isPLP && this.matchMediaQuery.matches;
    const isPDP = !this.isPLP;

    if (isPDP || isPLPAndShouldApply) {
      // Attach event listeners
      this.header?.addEventListener(
        "click",
        this.toggleView.bind(this),
      );
    } else if (this.isPLP) {
      // Detach event listeners for PLP when not applicable
      this.header?.removeEventListener(
        "click",
        this.toggleView.bind(this),
      );
    }
  }

  toggleView(e) {
    e.preventDefault();
    e.stopPropagation();

    if (
      this.closest(".constructor-autocomplete--products") &&
      window.innerWidth < 1280
    ) {
      if (this.closest("product-card")) {
        window.location.href = this.closest("product-card").getAttribute("url");
        return;
      }
    }

    this.classList.toggle("expanded");
  }

  expandDetailedView(e) {
    e.preventDefault();
    e.stopPropagation();
    if (
      this.closest(".constructor-autocomplete--products") &&
      window.innerWidth < 1280
    ) {
      if (this.closest("product-card")) {
        window.location.href = this.closest("product-card").getAttribute("url");
        return;
      }
    }

    if (this.classList.contains("expanded")) return;

    this.classList.add("expanded");
  }

  collapseDetailedView(e) {
    e.preventDefault();
    e.stopPropagation();

    if (!this.classList.contains("expanded")) return;

    this.classList.remove("expanded");
  }
}

customElements.define("special-order", SpecialOrder);

// Handle Special Order Modal for Product Cards
// Delegate click events for info buttons
document.addEventListener('click', function (e) {
  const infoBtn = e.target.closest('.special-order__info-btn');
  if (infoBtn) {
    e.preventDefault();
    e.stopPropagation();

    const productCard = infoBtn.closest('.card-wrapper, product-card');
    if (productCard) {
      const modal = productCard.querySelector('.special-order-modal');
      if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    }
  }

  // Close modal on overlay or close button click
  const closeBtn = e.target.closest('.special-order-modal__close');
  const overlay = e.target.classList.contains('special-order-modal__overlay');

  if (closeBtn || overlay) {
    e.preventDefault();
    e.stopPropagation();

    const modal = e.target.closest('.special-order-modal');
    if (modal) {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  // Close modal on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const activeModal = document.querySelector('.special-order-modal.active');
      if (activeModal) {
        activeModal.classList.remove('active');
        document.body.style.overflow = '';
      }
    }
  });
});

class CustomDate extends HTMLElement {
  constructor() {
    super();
    this.formatDate();
  }

  formatDate() {
    // expecting YYYY-MM-DD format
    //const d = new Date(Date.parse(this.dataset.date)).toISOString();
    const date = new Date(this.dataset.date);
    const utcDateString = date.toUTCString().slice(0, -4);
    const d = new Date(utcDateString).toDateString();

    // format date to 'Jan 20, 2023'
    const formatedDate = d
      .split(" ")
      .reduce((accumulator, currentValue, currentIndex) => {
        if (currentIndex > 0) {
          accumulator +=
            accumulator.length === 0 ? currentValue : " " + currentValue;
          if (currentIndex === 2) {
            accumulator += ",";
          }
        }
        return accumulator;
      }, "");

    this.textContent = ` ${formatedDate}`;
  }
}

customElements.define("custom-date", CustomDate);

// Global Special Order Modal Component
class SpecialOrderModal extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.triggerFromAutocompleteMenu = false;
  }

  connectedCallback() {
    this.render();
    this.setupEventListeners();
  }

  render() {
    this.innerHTML = `
      <div class="special-order-modal-global" style="display: none;">
        <div class="special-order-modal__overlay"></div>
        <div class="special-order-modal__content">
          <div class="special-order-modal__header">
            <span class="special-order-modal__title"></span>
            <button type="button" class="special-order-modal__close" aria-label="Close">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
          <div class="special-order-modal__body"></div>
        </div>
      </div>
    `;
  }

  renderTitle({ specialOrderDateLabel, orderSelection }) {
    const title = this.querySelector('.special-order-modal__title');
    const header = this.querySelector('.special-order-modal__header');
    const rawOrderSelection = this.querySelector('.special-order-modal__content').dataset.orderSelection || '';
    const specialOrderDate = rawOrderSelection.includes(':') ? rawOrderSelection.split(':')[1] : '';

    if (orderSelection === 'early_access') {
      const shipByDate = specialOrderDate
        ? `<span><custom-date class="special-order__date" data-date="${specialOrderDate}"></custom-date></span>`
        : '';
      title.innerHTML = `
        <div class="early-access-title" style="display: flex; align-items: start; gap: 10px; flex-direction: column; justify-content: start;">
          ${shipByDate}
          <div class="early-access-badge" style="display: flex; align-items: center; gap: 10px; flex-direction: row; justify-content: start;">
            <img src="https://cdn.shopify.com/s/files/1/1098/0290/files/early-access-lovepop-logo-48x48.png?v=1772636250" alt="Early Access" class="special-order__early-access-icon" width="16" height="16" />
            <span style="margin-left: 4px; font-size: 12px; font-weight: 500;">Stash Pass Member Early Access</span>
          </div>
        </div>
      `;
      header.style.alignItems = 'baseline';
    } else { 
      title.innerHTML = `
        <span>${specialOrderDateLabel ? (specialOrderDateLabel + ':') : 'Special Order:'}</span>
        <custom-date class="special-order__date" data-date="${specialOrderDate}"></custom-date>
      `;
      header.style.alignItems = 'center';
    }
  }

  renderBody({ specialOrderDateLabel, orderSelection, availableQuantity }) {
    const body = this.querySelector('.special-order-modal__body');
    const rawOrderSelection = this.querySelector('.special-order-modal__content').dataset.orderSelection || '';
    const specialOrderDate = rawOrderSelection.includes(':') ? rawOrderSelection.split(':')[1] : '';
    

    if (orderSelection === 'early_access') {
      const isLoggedIn = !!window.customer.id;
      const isUserHasSubscription = window.customer.tags?.some(tag => tag.toLowerCase().includes('active product subscription'));
      const hasInventory = Number(availableQuantity) > 0;

      console.log('[EarlyAccess Debug] renderBody', rawOrderSelection);

      if (hasInventory && isLoggedIn && isUserHasSubscription) {
        body.innerHTML = specialOrderDate
          ? `<p>Items will be shipped once they are available and will arrive separately from the rest of your order. Personalization is not available for early access items.</p>`
          : `<p>With Stash Pass Membership, you get exclusive early access!</p>`;
      } else {
        const stashPassLink = `${window.location.origin}/stash-up`;
        body.innerHTML = `
          <p>
            This early access item is available to Stash Pass members before everyone else. <a href="#" class="login-link js-open-auth-popup" style="text-decoration: underline; color: inherit;">Login</a> or <a href="${stashPassLink}" style="text-decoration: underline; color: inherit;">Join Stash Pass</a> to get yours first.
          </p>
        `;
        // setTimeout(() => {
        //   const loginLink = document.querySelector(".special-order-modal__body a.login-link");
        //   console.log('loginLink', loginLink);
        //   loginLink?.addEventListener("click", (e) => {
        //     e.preventDefault();
        //     window.onClickLogin?.();
        //   });
        // }, 200);
      }
    } else {
      const label = specialOrderDateLabel ? specialOrderDateLabel : 'Special order';
      body.innerHTML = `
        <p>
          <span class="special-order-label">${label}</span> 
          items will be shipped once they are available and will arrive separately from the rest of your order. Personalization is not available for ${label.toLowerCase()} items.
        </p>
      `;
    }
  }

  setupEventListeners() {
    const modal = this.querySelector('.special-order-modal-global');
    const closeBtn = this.querySelector('.special-order-modal__close');
    const overlay = this.querySelector('.special-order-modal__overlay');

    closeBtn?.addEventListener('click', () => this.close());
    overlay?.addEventListener('click', () => this.close());
  }

  open(data) {
    const { orderSelection, availableQuantity } = data;
    const modal = this.querySelector('.special-order-modal-global');
    const header = this.querySelector('.special-order-modal__header');
    const content = this.querySelector('.special-order-modal__content');
    const normalizedOrderSelection = typeof orderSelection === 'string'
      ? orderSelection.split(":")[0]
      : '';
    const specialOrderDate = typeof orderSelection === 'string' && orderSelection.includes(':')
      ? orderSelection.split(':')[1]
      : '';

    console.log('test', orderSelection, availableQuantity, specialOrderDate);

    content.dataset.orderSelection = orderSelection || '';

    // Update modal class for styling
    const customClass = normalizedOrderSelection ? normalizedOrderSelection + '-style' : ''
    header.className = `special-order-modal__header ${customClass}`;
    console.log('Applying custom class to modal header:', data);
    this.renderTitle({ ...data, orderSelection: normalizedOrderSelection });
    this.renderBody({ ...data, orderSelection: normalizedOrderSelection });
 
    // Show modal
    modal.style.display = 'block';
    this.isOpen = true;
    document.body.style.overflow = 'hidden';

    if (document.querySelector('.constructor-layouts--autocomplete--dropdown__container')) {
      this.triggerFromAutocompleteMenu = true;
    } else {
      this.triggerFromAutocompleteMenu = false;
    }
  }

  close() {
    const modal = this.querySelector('.special-order-modal-global');
    modal.style.display = 'none';
    this.isOpen = false;
    document.body.style.overflow = '';
    if (this.triggerFromAutocompleteMenu) {
      window.openAutocompleteMenu();
    }
  }
}

customElements.define('special-order-info-modal', SpecialOrderModal);

// replace cart with Cart in add to cart buttons

function replaceButtonText(buttonId, text) {
  var button = document.querySelector('button[name="add"] span');
  if (button) {
    if (button.childNodes[0]) {
      button.childNodes[0].nodeValue = text;
    } else if (button.value) {
      button.value = text;
    } //if (button.innerHTML)
    else {
      button.innerHTML = text;
    }
  }
}
replaceButtonText("myButton1", "Add to Cart");

// document.body.addEventListener('mousemove', function(event) {
//   var header_inline = document.querySelector('.header__inline-menu');
//   if(!header_inline.contains(event.target)){
//     document.querySelectorAll('nav.header__inline-menu details').forEach(x => x.removeAttribute('open'));
//   }
// });

document
  .querySelectorAll(".list-menu.list-menu--inline li:has(a.header__menu-item)")
  .forEach((item) => {
    item.addEventListener("mouseenter", () =>
      document
        .querySelectorAll("details")
        .forEach((x) => x.removeAttribute("open")),
    );
  });

window.getEndpoint = () => {
  const location = window.location.origin;
  let env = ''

  if (location.includes('test')) {
    env = 'test'
  } else if (location.includes('staging')) {
    env = 'staging'
  } else if (location.includes('prod')) {
    env = 'prod'
  }

  switch (env) {
    case 'test':
      return 'https://bt8x9lvpe3.execute-api.us-west-2.amazonaws.com/dev/';
    case 'staging':
      return 'https://pyyi2h5am7.execute-api.us-west-2.amazonaws.com/staging/'
    case 'prod':
      return 'https://57rcqblb3f.execute-api.us-west-2.amazonaws.com/prod/'
    default:
      return 'https://57rcqblb3f.execute-api.us-west-2.amazonaws.com/prod/'
  }
};

function setupProductImagesSwipeOnPLP(slidesContainer) {
  let startX = 0,
    currentTranslate = 0,
    prevTranslate = 0,
    currentSlide = 0;
  let isSwiping = false; // Flag to check if swiping is enabled
  const totalSlides = slidesContainer.children.length;

  slidesContainer.addEventListener("touchstart", (e) => {
    if (e.touches.length > 1) {
      isSwiping = false; // More than one touch indicates pinch; disable swipe
    } else {
      isSwiping = true;
      startX = e.touches[0].clientX;
      slidesContainer.style.transition = "none";
    }
  });

  slidesContainer.addEventListener("touchmove", (e) => {
    if (!isSwiping) return; // Exit if swipe is disabled
    const diff =
      ((e.touches[0].clientX - startX) / slidesContainer.clientWidth) * 100; // Convert px to percentage
    currentTranslate = prevTranslate + diff;
    slidesContainer.style.transform = `translateX(${currentTranslate}%)`;
  });

  slidesContainer.addEventListener("touchend", (e) => {
    if (!isSwiping) return; // Exit if swipe is disabled
    const movedBy = currentTranslate - prevTranslate;

    if (movedBy < -20 && currentSlide < totalSlides - 1) currentSlide++;
    if (movedBy > 20 && currentSlide > 0) currentSlide--;

    prevTranslate = -currentSlide * 100;
    slidesContainer.style.transition = "transform 0.3s ease";
    slidesContainer.style.transform = `translateX(${prevTranslate}%)`;

    const productCard = slidesContainer.closest("product-card");
    if (productCard) {
      if (currentSlide === 1) {
        productCard.classList.remove("slide-1");
        productCard.classList.add("slide-2");
      } else {
        productCard.classList.remove("slide-2");
        productCard.classList.add("slide-1");
      }
    }
  });
}

/*-- Disabling gift card options in personalization modal --*/
/*
window.addEventListener("load", () => {
  const cartTriggers = document.querySelectorAll('.cart-item__personalization-buttons > #personalization-button');

  [].map.call(cartTriggers, (trigger) =>{
    trigger.addEventListener("click", () => {
      hidingGiftSection();
    });
  });
  
  if (window.location.href.indexOf("products") > -1) {
    const pdpTrigger = document.querySelector('.product-form > #personalization-button');
    pdpTrigger.addEventListener("click", () => {
      hidingGiftSection();
    });
  }
  

  
  const hidingGiftSection = () => {
    console.log("personalization modal opened");
    setTimeout(() =>{
      let nextButtons = document.querySelectorAll('nav[aria-label="personalization-navigation"] button');
      
      [].map.call(nextButtons, (button) => {
        button.addEventListener("click", () =>{
          console.log("clicking on nav button");
          setTimeout(() => {
            let container = document.querySelector('.noteEditor__container');
          
            if(button.getAttribute("data-heap-step") == "5"){
              container.style.display = 'none';
              
            } 
            else if (button.getAttribute("data-heap-step") == "6") {
              setTimeout(() => {
                let backButton = document.querySelector('button[data-heap-button="back"]');
              backButton.style.display = 'none';
              }, "300");
            }
            else {
              container.style.display = 'block';
            }
          }, "300");     
        });
      });
    }, "500");
        
  }

});
*/

window.reloadCartBubble = async () => {
  var sections_to_render = [
    {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: "#cart-icon-bubble,#shopify-section-cart-icon-bubble"
    },
  ]

  const getSectionInnerHTML = (html, selector = ".shopify-section") => {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  try {
    const response = await fetch(
      `${window.location.pathname}?sections=${sections_to_render
        .map((section) => section.section)
        .join(",")}`,
      { cache: "no-store" },
    );
    const parsedState = await response.json();

    sections_to_render.forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (sectionElement) {
        sectionElement.innerHTML = getSectionInnerHTML(
          parsedState[section.id],
          section.selector,
        );
      }
    });
  } catch (err) {
    console.log(err);
  }
}

window.showCartTooltipWithFiveforfifty = (isSas = false, showActions = true, productData) => {
  const getSectionInnerHTML = (html, selector = ".shopify-section") => {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  const fetchUrl = window?.isCartPage
    ? `${window.location.pathname}?sections=five-fifty-count,five-fifty-progress-bar,mothers-day-cross-sell-in-cart`
    : `${window.location.pathname}?sections=five-fifty-count,five-fifty-progress-bar,mothers-day-cross-sell`;

  Promise.all([
    fetch(fetchUrl).then((response) => response.json()),
    fetch('/cart.js').then((response) => response.json()),
  ])
    .then(([data, cart]) => {
      const isStashPassInCart = cart.items.some(
        (item) => item.handle && item.handle.includes('stash-pass')
      );

      const section = data['five-fifty-count'];
      const fiveFiftyProgressBarSection = data['five-fifty-progress-bar'];
      const mothersDayCrossSellSection = data['mothers-day-cross-sell'];
      const mothersDayCrossSellInCartSection = data['mothers-day-cross-sell-in-cart'];
      const sectionScript = getSectionInnerHTML(section, "#five-fifty-progress-bar-data");

      const fiveFiftyProgressBarSectionHtml = getSectionInnerHTML(fiveFiftyProgressBarSection, "#shopify-section-five-fifty-progress-bar");
      document.querySelector('.cart-popup-five-fifty-progress-bar').innerHTML = fiveFiftyProgressBarSectionHtml;
      
      if(window.isCartPage){
        const motherDaysInCartSectionContainer = document.querySelector('.cart-popup-mothers-day-cross-sell-in-cart')
        motherDaysInCartSectionContainer.innerHTML = getSectionInnerHTML(mothersDayCrossSellInCartSection,"#shopify-section-mothers-day-cross-sell-in-cart");
      }else{
        const isMothersDayProduct = String(productData?.isMothersDay).toLowerCase() === "true";
        const motherDaysSectionContainer = document.querySelector('.cart-popup-mothers-day-cross-sell')
        motherDaysSectionContainer.innerHTML = isMothersDayProduct ? getSectionInnerHTML(mothersDayCrossSellSection,"#shopify-section-mothers-day-cross-sell") : "";
      }
    
      const progressData = JSON.parse(sectionScript);

      let text = productData?.customTitle || (isSas ? 'Personalization Card Added to Cart' : 'Product Added to Cart');

      if (progressData && progressData.remaining_quantity > 0) {
        // text = isSas ? window.tooltipTextFiveForFifty.personalizationCard.notMatched.replace('[[remaining_quantity]]', progressData.remaining_quantity) : window.tooltipTextFiveForFifty.normalCard.notMatched.replace('[[remaining_quantity]]', progressData.remaining_quantity);
      } else if (progressData && progressData.remaining_quantity == 0) {
        // text = isSas ? window.tooltipTextFiveForFifty.personalizationCard.matched : window.tooltipTextFiveForFifty.normalCard.matched;
      } else {
        // text = isSas ? window.tooltipTextFiveForFifty.personalizationCard.overLimit : window.tooltipTextFiveForFifty.normalCard.overLimit;
      }

      window.showAddTocartTooltip(text, showActions, { ...productData, isStashPassInCart });

      window.celebrateCartUnlock?.(progressData, cart);

    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// Store the timeout ID globally
window.cartPopupTimeoutId = null;

window.showAddTocartTooltip = (text = `Card added to your cart`, showActions = true, productData) => {
  const cartPopup = document.getElementById('cart-popup');
  if (!cartPopup) return;
  const fiveForFifty = cartPopup.querySelector('.five-for-fifty');
  const keepShopping = cartPopup.querySelector('.keep-shopping');
  const gotoCartBtn = cartPopup.querySelector('.go-to-cart');
  const closeBtn = cartPopup.querySelector('.close-btn');
  const cartPopupIcon = cartPopup.querySelector('.cart-popup-icon');
  const cartPopupText = cartPopup.querySelector('.cart-popup-text');
  const cartPopupItem = cartPopup.querySelector('.cart-popup-item');
  const overlay = document.querySelector('.cart-popup-overlay');
  const fiveFiftyProgressBar = cartPopup.querySelector('.cart-popup-five-fifty-progress-bar');
  const stashMessage = cartPopup.querySelector('.stash-pass-message');
  const isStashPass = productData?.isStashPass;
  const isUserHasSubcription = window.customer?.tags?.includes('Active product subscription');
  const isStashPassContext = !isStashPass && (isUserHasSubcription || productData?.isStashPassInCart);

  cartPopup.classList.remove('stash-popup');
  stashMessage?.classList.add('hidden');
  stashMessage?.classList.remove('stash-pass-message--column');
  keepShopping?.classList.add('hidden');

  if (isStashPass) {
    cartPopup.classList.add('stash-popup');
    cartPopupText.innerHTML = text;

    const motherDaysSectionContainer = cartPopup.querySelector('.cart-popup-mothers-day-cross-sell');
    if (motherDaysSectionContainer) motherDaysSectionContainer.innerHTML = '';

    if (stashMessage) {
      let stashContent = productData.stashMessage || '';

      if (text !== "Stash Pass Added to Cart") {
        stashContent += `<p class="cart-help-link">Need help? <a href="/pages/contact-support">Please contact support.</a> </p>`;
        document.querySelector('.cart-popup-actions')?.classList.add('hidden');
        stashMessage.classList.add('stash-pass-message--column');
      }

      stashMessage.innerHTML = stashContent;
      stashMessage.classList.remove('hidden');
    }
  } else {
    cartPopupText.innerHTML = text;
    document.querySelector('.cart-popup-actions')?.classList.remove('hidden');

    if (isStashPassContext && stashMessage && showActions) {
      stashMessage.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style="flex-shrink:0"><g clip-path="url(#clip0_stash_savings)"><path d="M9.91667 6.12508C9.91667 6.28616 10.0473 6.41675 10.2083 6.41675C10.3694 6.41675 10.5 6.28616 10.5 6.12508C10.5 5.964 10.3694 5.83342 10.2083 5.83342C10.0473 5.83342 9.91667 5.964 9.91667 6.12508Z" fill="#333"></path><path d="M9.91667 1.16675H6.31633C6.00694 1.16681 5.71024 1.28977 5.4915 1.50858L1.57733 5.42275C1.3332 5.66501 1.18678 5.98867 1.16601 6.33198C1.14525 6.6753 1.25159 7.01424 1.46475 7.28417M12.8333 7.68375C12.8333 7.99314 12.7103 8.28984 12.4915 8.50858L8.57733 12.4227C8.44719 12.554 8.29234 12.6581 8.12174 12.7292C7.95114 12.8003 7.76815 12.8369 7.58333 12.8369C7.39852 12.8369 7.21553 12.8003 7.04493 12.7292C6.87432 12.6581 6.71948 12.554 6.58933 12.4227L3.91067 9.74408C3.77945 9.61393 3.6753 9.45909 3.60422 9.28849C3.53314 9.11789 3.49655 8.9349 3.49655 8.75008C3.49655 8.56527 3.53314 8.38228 3.60422 8.21167C3.6753 8.04107 3.77945 7.88623 3.91067 7.75608L7.82483 3.84191C8.04357 3.62311 8.34027 3.50015 8.64967 3.50008H12.25C12.4047 3.50008 12.5531 3.56154 12.6625 3.67094C12.7719 3.78033 12.8333 3.92871 12.8333 4.08341V7.68375ZM9.91667 6.12508C9.91667 6.28616 10.0473 6.41675 10.2083 6.41675C10.3694 6.41675 10.5 6.28616 10.5 6.12508C10.5 5.964 10.3694 5.83342 10.2083 5.83342C10.0473 5.83342 9.91667 5.964 9.91667 6.12508Z" stroke="#333" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_stash_savings"><rect width="14" height="14" fill="white" transform="matrix(0 1 -1 0 14 0)"></rect></clipPath></defs></svg><p style="margin:0">You're saving 15% on this item with Stash Pass.</p>`;
      stashMessage.classList.remove('hidden');
      fiveForFifty?.classList.add('hidden');
      keepShopping?.classList.remove('hidden');
    }
  }

  if (cartPopupItem && productData) {
    cartPopupItem.classList.remove('hidden');

    const image = cartPopupItem.querySelector('img');
    const title = cartPopupItem.querySelector('.cart-popup-item-title');

    if (image && productData.image) {
      image.src = productData.image;
      image.alt = productData.productTitle || '';
    }

    if (title && productData.productTitle) {
      title.textContent = productData.productTitle;
    }

    const quantityEl = cartPopupItem.querySelector('.cart-popup-item-quantity');
    if (quantityEl) {
      const qty = Number(productData.quantity);
      if (qty > 0) {
        quantityEl.textContent = `Quantity: ${qty}`;
        quantityEl.classList.remove('hidden');
      } else {
        quantityEl.textContent = '';
        quantityEl.classList.add('hidden');
      }
    }

    const personalizedNote = cartPopupItem.querySelector('.cart-popup-item-personalized');
    if (personalizedNote) {
      if (productData.isPersonalized) {
        personalizedNote.removeAttribute('hidden');
      } else {
        personalizedNote.setAttribute('hidden', '');
      }
    }
  }

  cartPopupText.innerHTML = text;

  if (showActions) {
    fiveForFifty.classList.remove('hidden');
    gotoCartBtn.classList.remove('hidden');
    fiveFiftyProgressBar.classList.remove('hidden');
    cartPopupItem.classList.remove('hidden');
    // cartPopupIcon.classList.add('hidden');
  } else {
    fiveForFifty.classList.add('hidden');
    gotoCartBtn.classList.add('hidden');
    fiveFiftyProgressBar.classList.add('hidden');
    cartPopupItem.classList.add('hidden');
    // cartPopupIcon.classList.remove('hidden');
  }

  // Clear existing timeout if it's still pending
  if (window.cartPopupTimeoutId) {
    clearTimeout(window.cartPopupTimeoutId);
  }

  if (productData?.hideProgressBar) {
    fiveFiftyProgressBar?.classList.add('hidden');
    cartPopup.classList.add('two-boxes-popup');
  } else {
    cartPopup.classList.remove('two-boxes-popup');
  }

  if (isUserHasSubcription || isStashPass || productData?.isStashPassInCart) {
    fiveForFifty.classList.add('hidden');
    fiveFiftyProgressBar?.classList.add('hidden');
  }

  cartPopup.classList.add('show');

  // Set a new timeout to hide popup
  if (!showActions) {
    window.cartPopupTimeoutId = setTimeout(() => {
      cartPopup.classList.remove('show');
      window.cartPopupTimeoutId = null; // Reset the ID
    }, 4000);
  }

  const closePopup = () => {
    cartPopup.style.display = 'none';
    cartPopup.classList.remove('show');
    clearTimeout(window.cartPopupTimeoutId);

    setTimeout(() => {
      cartPopup.style.display = 'block';
    }, 500);
  }

  // Only add click listeners once
  if (!window._cartPopupListenersAdded) {
    fiveForFifty?.addEventListener('click', closePopup);
    keepShopping?.addEventListener('click', closePopup);
    closeBtn?.addEventListener('click', closePopup);
    overlay?.addEventListener('click', closePopup);

    window._cartPopupListenersAdded = true;
  }

  if (window.location.href.indexOf("cart") === -1) {
    window.reloadCartBubble?.();
  }
};

window.onOpenAuthenticationPopup = function() {
  const authenticationBtn = document.querySelector('sticky-header .header__icons .new__header__account a[aria-label="Account"]');
  if (authenticationBtn) {
    authenticationBtn.click();
  }
  return false;
}

document.addEventListener('click', function(event) {
  const authLink = event.target.closest('.js-open-auth-popup');
  if (authLink) {
    event.preventDefault();
    window.onOpenAuthenticationPopup?.();
    return;
  }

  const stashButton = event.target.closest('.js-go-stash-pass');
  if (stashButton) {
    event.preventDefault();
    const href = stashButton.dataset.href || '/stash';
    window.location.href = href;
  }
});
